import React, { useCallback, useState } from 'react';
import { Content } from '@visikon/core-models';
import { Tag } from './Tag';

interface IProps {
  onTagRemoved?: (tag: Content.Tag) => void;
  onTagAdded?: (tags: Content.Tag[]) => void;
  tagList: Content.Tag[];
  header?: string;
  readOnly?: boolean;
}
export function TagList(props: IProps) {
  const { tagList, onTagRemoved, onTagAdded, header, readOnly } = props;
  const [isAddingTag, setIsAddingTag] = useState(false);
  const [editText, setEditText] = useState('');

  const handleAddBegin = useCallback(() => {
    setIsAddingTag(true);
  }, []);

  const handleAddOnBlur = useCallback(() => {
    setIsAddingTag(false);
    setEditText('');
  }, []);

  const handleAddOnChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setEditText(event.target.value);
  }, []);

  const addTag = useCallback(() => {
    const tagsToAdd = editText
      .split(';')
      .map((tag) => tag.trim())
      .filter((tag, index, self) => !!tag && !tagList.includes(tag) && self.indexOf(tag) === index);

    if (tagsToAdd.length > 0 && onTagAdded) {
      onTagAdded(tagsToAdd as Content.Tag[]);
      setEditText('');
    }
  }, [editText, onTagAdded, tagList]);

  const handleAddKeyPress = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter' || event.key === 'Tab') {
        addTag();
        event.preventDefault();
      }
    },
    [addTag],
  );

  return (
    <div style={{ zIndex: 10 }}>
      {tagList?.map((tag, i) => (
        <Tag onDelete={onTagRemoved} key={i} text={tag} readOnly={readOnly} />
      ))}
      {isAddingTag && (
        <div className="ui left icon mini input" style={{ display: 'inline-block', marginLeft: '0.5rem', marginTop: '10px' }}>
          <i className="tags icon" />

          {/* eslint-disable jsx-a11y/no-autofocus */}
          <input
            placeholder="Enter tag"
            type="text"
            value={editText}
            autoFocus
            onBlur={handleAddOnBlur}
            onChange={handleAddOnChange}
            onKeyDown={handleAddKeyPress}
          />
        </div>
      )}
      {header && tagList.length === 0 && !isAddingTag && (
        <h5 className="ui header" style={{ display: 'inline-block', margin: '15px 0 0 0' }}>
          {header}
        </h5>
      )}
      {!isAddingTag && !readOnly && (
        <div style={{ display: 'inline-block', marginLeft: '0.5rem', marginTop: '15px', cursor: 'pointer' }}>
          {/* eslint-disable-next-line  */}
          <a onClick={handleAddBegin}>
            <i className="large green add icon circle" />
          </a>
        </div>
      )}
    </div>
  );
}
